const ON_CHANGE_DEBOUNCE_TIMER = 300;
// Shorter than ON_CHANGE_DEBOUNCE_TIMER: variant info updates should feel
// instant while still coalescing rapid swatch clicks into one section fetch.
const ON_VARIANT_CHANGE_DEBOUNCE_TIMER = 150;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
